import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';
import { RealtimeChannel } from '@supabase/supabase-js';

interface PresenceState {
  [key: string]: {
    user_id: string;
    username: string;
    online_at: string;
  }[];
}

export const usePresence = () => {
  const [onlineUsers, setOnlineUsers] = useState<number>(0);
  const [presenceState, setPresenceState] = useState<PresenceState>({});
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    let channel: RealtimeChannel;

    const setupPresence = async () => {
      channel = supabase.channel('online-users');

      channel
        .on('presence', { event: 'sync' }, () => {
          const state = channel.presenceState<{
            user_id: string;
            username: string;
            online_at: string;
          }>();
          setPresenceState(state);
          setOnlineUsers(Object.keys(state).length);
        })
        .on('presence', { event: 'join' }, ({ key, newPresences }) => {
          console.log('User joined:', newPresences);
        })
        .on('presence', { event: 'leave' }, ({ key, leftPresences }) => {
          console.log('User left:', leftPresences);
        })
        .subscribe(async (status) => {
          if (status === 'SUBSCRIBED') {
            await channel.track({
              user_id: user.id,
              username: user.email?.split('@')[0] || 'Anonymous',
              online_at: new Date().toISOString(),
            });
          }
        });
    };

    setupPresence();

    return () => {
      if (channel) {
        channel.untrack();
        supabase.removeChannel(channel);
      }
    };
  }, [user]);

  return { onlineUsers, presenceState };
};
